/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetMultipleBundlesRequest
 */
export interface GetMultipleBundlesRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof GetMultipleBundlesRequest
     */
    bundles?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetMultipleBundlesRequest
     */
    files?: Array<number>;
}

export function GetMultipleBundlesRequestFromJSON(json: any): GetMultipleBundlesRequest {
    return GetMultipleBundlesRequestFromJSONTyped(json, false);
}

export function GetMultipleBundlesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMultipleBundlesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bundles': !exists(json, 'bundles') ? undefined : json['bundles'],
        'files': !exists(json, 'files') ? undefined : json['files'],
    };
}

export function GetMultipleBundlesRequestToJSON(value?: GetMultipleBundlesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bundles': value.bundles,
        'files': value.files,
    };
}


